import { Component, OnDestroy, OnInit } from '@angular/core';

import { FocustipService } from './focustip.service';

@Component({
	selector: 'app-focustip',
	templateUrl: './focustip.component.html',
	styleUrls: ['./focustip.component.css'],
})
export class FocustipComponent implements OnInit, OnDestroy {
	private subscription;
	data = {
		element: null,
		text: null,
	};

	constructor(private readonly focustipService: FocustipService) {}

	ngOnInit(): void {
		this.subscription = this.focustipService.focustip.subscribe((data) => {
			if (!data.element || !data.text) {
				document.getElementById('focustipContainer').style.display = 'none';
				return;
			}
			document.getElementById('focustipContainer').style.display = 'block';
			const messageElement = document.getElementById('focustipMessage');
			const insideElementCoordinates = this.getOffset(data.element);
			//
			messageElement.style.top = insideElementCoordinates.top + insideElementCoordinates.height + 'px';
			messageElement.style.left = insideElementCoordinates.left + 'px';
			const messageElementCoordinates = this.getOffset(messageElement);
			//
			document.getElementById('boxleft').style.width = insideElementCoordinates.left + 'px';
			document.getElementById('boxleft').style.height =
				messageElementCoordinates.top + messageElementCoordinates.height + 'px';
			//
			document.getElementById('boxtop').style.height = insideElementCoordinates.top + 'px';
			//
			document.getElementById('boxright').style.left =
				insideElementCoordinates.left + insideElementCoordinates.width + 'px';
			document.getElementById('boxright').style.height =
				messageElementCoordinates.top + messageElementCoordinates.height + 'px';
			//
			document.getElementById('boxbottom').style.top =
				messageElementCoordinates.top + messageElementCoordinates.height + 'px';
			//
			this.data = data;
			data.element.focus();
		});
	}

	ngOnDestroy(): void {
		if (this.subscription) {
			this.subscription.unsubscribe();
		}
	}

	private getOffset(element) {
		const rect = element.getBoundingClientRect();
		return {
			left: rect.left + window.pageXOffset,
			top: rect.top, // + window.pageYOffset,
			width: rect.width || element.offsetWidth,
			height: rect.height || element.offsetHeight,
		};
	}
}
